import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import NavBar from '../blocks/NavBar';

import './news-pages.css';

const $ = window.jQuery;

class NewsPage extends React.PureComponent {
  constructor() {
    super();
    this.state = {
      tt: {},
      news: [],
    };
  }

  componentDidMount() {
    this.handleChangeLng(this.props.locale);
    this.scrollToTop();
  }

  componentDidUpdate(prevProps) {
    if (this.props.locale !== prevProps.locale) {
      this.handleChangeLng(this.props.locale);
    }
    this.scrollToTop();
  }

  scrollToTop() {
    window.scrollTo(0, 0);
  }

  handleChangeLng(locale) {
    $.getJSON(`/locales/${locale}.json`, (tt) => {
      this.setState({ tt });
    });

    $.getJSON(`/events/${locale}.json`, (news) => {
      this.setState({ news });
    });
  }

  render() {
    const {
      locale,
      match: { params: { date } }
    } = this.props;
    const {
      tt,
      news,
    } = this.state;
    if (!Object.keys(tt).length || !Object.keys(news).length) return null;
    const currentNews = news.find(item => item.date === date);
    if (!currentNews) return null;

    const newsIndex = news.findIndex(item => item.date === date);
    const prevNewsDate = news[newsIndex - 1] && news[newsIndex - 1].date;
    const nextNewsDate = news[newsIndex + 1] && news[newsIndex + 1].date;
    return (
      <div className="news-page">
        <NavBar tt={tt} locale={locale} />
        <ul className="side-nav" id="mobile-demo">
          <li><a href="badges.html">{tt.menu.changeLng}</a></li>
          <li><a href="badges.html">{tt.menu.shopNow}</a></li>
        </ul>
        <div className="kv">
          <div
            className="image blur"
            style={{
              backgroundImage: `url(${currentNews.image})`
            }}
          />
          <div className="container">
            <div
              className="image"
              style={{
                backgroundImage: `url(${currentNews.image})`
              }}
            >
              {
                prevNewsDate &&
                <Link
                  to={`${locale ? `/${locale}` : ''}/news/${prevNewsDate}`}
                  className="prev material-icons"
                >
                  keyboard_arrow_left
                </Link>
              }
              {
                nextNewsDate &&
                <Link
                  to={`${locale ? `/${locale}` : ''}/news/${nextNewsDate}`}
                  className="next material-icons"
                >
                  keyboard_arrow_right
                </Link>
              }
            </div>
          </div>
        </div>
        <section>
          <div className="container">
            <header>
              <h1 className="heading">{currentNews.title}</h1>
              <div className="date">{currentNews.date}</div>
            </header>
            <ReactMarkdown source={currentNews.text} />
          </div>
        </section>
      </div>
    );
  }
}

export default NewsPage;

NewsPage.propTypes = {
  locale: PropTypes.string,
  match: PropTypes.object,
};

NewsPage.defaultProps = {
  locale: '',
  match: {},
};



// WEBPACK FOOTER //
// ./src/NewsPage/index.js